import type { SegmentClientName, SegmentEventQueueEvent } from '@/typings/segment-manager';

/** Keep early calls and the eventual client's queue on the same array. */
export function getSegmentEventQueue(source: SegmentClientName): SegmentEventQueueEvent[] {
  if (source === 'website') {
    window.segmentWebsiteEventQueue ??= [];

    return window.segmentWebsiteEventQueue;
  }

  window.segmentEventQueue ??= [];

  return window.segmentEventQueue;
}
